import { ArrowRightIcon, Form, handleApiRequest } from "@cpj-ai/panel-npm-package";
import {
  UpdateInterestedJobsMutation,
  UpdateInterestedJobsMutationVariables,
  useGetInterestedJobsQuery,
  useUpdateInterestedJobsMutation,
} from "@graphql/generated";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { getInputConfig } from "./formConfig";

interface JobLocationTabContentProps {
  goToNextTab: () => void;
}

const JobLocationTabContent: React.FC<JobLocationTabContentProps> = ({ goToNextTab }) => {
  const formHandler = useForm();

  const { data: userData, refetch } = useGetInterestedJobsQuery();
  const [updateInterestedJObs, { loading: submitLoading }] = useUpdateInterestedJobsMutation();

  const handleSubmit = useCallback(async () => {
    const formData = formHandler.getValues();
    const selectedCities = formData.jobCity?.filter((item: any) => item.node.id !== "all");

    await handleApiRequest<UpdateInterestedJobsMutation, UpdateInterestedJobsMutationVariables>({
      apiFunction: updateInterestedJObs,
      variables: {
        jobCities: selectedCities?.map((city: any) => city.node.id),
      },
      componentName: "JobLocationForm",
      actionName: "updateJobLocations",
      successMessage: "Job location updated successfully",
      fallbackErrorMessage: "Failed to update job locations. Please try again.",
      extraErrorContext: {
        cityCount: selectedCities?.length,
      },
      onSuccess: () => {
        refetch();
        goToNextTab();
      },
    });
  }, [formHandler, goToNextTab, refetch, updateInterestedJObs]);

  useEffect(() => {
    if (!userData) return;

    formHandler.reset({
      jobCity:
        (userData?.me?.profile?.jobCities.edges?.length ?? 0) > 0
          ? userData?.me?.profile?.jobCities.edges
          : [
              {
                node: {
                  id: "all",
                  name: "All cities",
                },
              },
            ],
    });
  }, [formHandler, userData]);

  formHandler.watch("jobCity");
  return (
    <div className="pt-3 flex flex-col gap-4">
      <Form
        wrapInCard={false}
        formHandler={formHandler}
        inputConfigs={getInputConfig()}
        showCancel={false}
        className="mt-0"
        submitProps={{
          onClick: formHandler.handleSubmit(handleSubmit),
          isLoading: submitLoading,
          isDisabled: submitLoading,
          children: "Save & Next",
          endContent: <ArrowRightIcon stroke="#fff" className="w-4 h-4" />,
        }}
      />
    </div>
  );
};

export default JobLocationTabContent;
